jQuery( '.faq-strip' ).on( 'click', function() {
    jQuery( '.faq-strip' ).not( this ).removeClass( 'open' );
    jQuery( this ).toggleClass( 'open' );
} );